import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product } from '../../shared/models/product';
import { DashboardAnalyticsResponse } from '../../shared/models/dashboard-analytics';
import { ApiHttpService } from './api-http.service';

@Injectable()
export class ProductService {
  constructor(private http: ApiHttpService) {}

  getTopCustomers(filters: { branches?: string[]; orderTypes?: string[]; startDate?: string; endDate?: string }) {
    let url = 'dashboard/customers/top-customer-by-order-amount';
    const params: string[] = [];

    if (filters.startDate) {
      params.push(`startDate=${encodeURIComponent(filters.startDate)}`);
    }

    if (filters.endDate) {
      params.push(`endDate=${encodeURIComponent(filters.endDate)}`);
    }

    if (filters.branches && filters.branches.length > 0) {
      filters.branches.forEach((branch) => {
        params.push(`branches=${encodeURIComponent(branch)}`);
      });
    }

    if (filters.orderTypes && filters.orderTypes.length > 0) {
      filters.orderTypes.forEach((orderType) => {
        params.push(`orderTypes=${encodeURIComponent(orderType)}`);
      });
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    return this.http.get(url);
  }

  getRecentSales(filters: { branches?: string[]; orderTypes?: string[]; startDate?: string; endDate?: string }) {
    let url = 'dashboard/recent/completed';
    const params: string[] = [];

    if (filters.startDate) {
      params.push(`startDate=${encodeURIComponent(filters.startDate)}`);
    }

    if (filters.endDate) {
      params.push(`endDate=${encodeURIComponent(filters.endDate)}`);
    }

    if (filters.branches && filters.branches.length > 0) {
      filters.branches.forEach((branch) => {
        params.push(`branches=${encodeURIComponent(branch)}`);
      });
    }

    if (filters.orderTypes && filters.orderTypes.length > 0) {
      filters.orderTypes.forEach((orderType) => {
        params.push(`orderTypes=${encodeURIComponent(orderType)}`);
      });
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    return this.http.get(url);
  }

  getDashboardAnalytics(filters: { branches?: string[]; orderTypes?: string[]; startDate?: string; endDate?: string }) {
    let url = 'dashboard/analytics';
    const params: string[] = [];

    if (filters.startDate) {
      params.push(`startDate=${encodeURIComponent(filters.startDate)}`);
    }

    if (filters.endDate) {
      params.push(`endDate=${encodeURIComponent(filters.endDate)}`);
    }

    if (filters.branches && filters.branches.length > 0) {
      filters.branches.forEach((branch) => {
        params.push(`branches=${encodeURIComponent(branch)}`);
      });
    }

    if (filters.orderTypes && filters.orderTypes.length > 0) {
      filters.orderTypes.forEach((orderType) => {
        params.push(`orderTypes=${encodeURIComponent(orderType)}`);
      });
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    return this.http.get(url);
  }

  getStoreAnalytics(filters: { branches?: string[]; orderTypes?: string[]; startDate?: string; endDate?: string }) {
    let url = 'dashboard/analytics/stores';
    const params: string[] = [];

    if (filters.startDate) {
      params.push(`startDate=${encodeURIComponent(filters.startDate)}`);
    }

    if (filters.endDate) {
      params.push(`endDate=${encodeURIComponent(filters.endDate)}`);
    }

    if (filters.branches && filters.branches.length > 0) {
      filters.branches.forEach((branch) => {
        params.push(`branches=${encodeURIComponent(branch)}`);
      });
    }

    if (filters.orderTypes && filters.orderTypes.length > 0) {
      filters.orderTypes.forEach((orderType) => {
        params.push(`orderTypes=${encodeURIComponent(orderType)}`);
      });
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    return this.http.get(url);
  }

  getChartsData(filters: { branches?: string[]; orderTypes?: string[]; startDate?: string; endDate?: string }) {
    let url = 'dashboard/charts';
    const params: string[] = [];

    if (filters.startDate) {
      params.push(`startDate=${encodeURIComponent(filters.startDate)}`);
    }

    if (filters.endDate) {
      params.push(`endDate=${encodeURIComponent(filters.endDate)}`);
    }

    if (filters.branches && filters.branches.length > 0) {
      filters.branches.forEach((branch) => {
        params.push(`branches=${encodeURIComponent(branch)}`);
      });
    }

    if (filters.orderTypes && filters.orderTypes.length > 0) {
      filters.orderTypes.forEach((orderType) => {
        params.push(`orderTypes=${encodeURIComponent(orderType)}`);
      });
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    return this.http.get(url);
  }
}
